import { Card, Text } from '@oneaudi/unified-web-components';
import React from 'react';
import {
  CardWrapper,
  CardContentWrapper,
  ImageWrapper,
  VehicleData,
  NameMileage,
  ClampedText,
  Image,
} from './SidewideSearch.styles';
import type { Vehicle } from '../../../types';

interface VehicleCardProps {
  vehicle: Vehicle;
  showPrice: boolean;
  type: string;
}

const VehicleCard: React.FC<VehicleCardProps> = ({ vehicle, showPrice, type }) => {
  const price =
    vehicle?.carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.formattedValue ??
    'Available Soon';
  const priceToRender = showPrice ? price : null;

  const isUsedVehicle = type === 'CPO' || type === 'USED';

  return (
    <CardWrapper key={vehicle.id} tabIndex={0} href={vehicle.weblink}>
      <Card margin={[0, 0, 0, 0]}>
        <CardContentWrapper>
          <ImageWrapper>
            <Image src={vehicle.imageUrl} />
          </ImageWrapper>
          <VehicleData>
            <NameMileage>
              <Text>
                <ClampedText>
                  {vehicle.modelYear} {vehicle.modelName}
                </ClampedText>
              </Text>
              {isUsedVehicle && (
                <Text variant={{ order: '2', style: 'normal' }} className="mileage">
                  {vehicle.odometerText}
                </Text>
              )}
            </NameMileage>
            <Text variant={{ order: '1', style: 'bold' }}>{priceToRender}</Text>
          </VehicleData>
        </CardContentWrapper>
      </Card>
    </CardWrapper>
  );
};

export default VehicleCard;
